import type { CustomErrorRule } from '@/core/error/transport/types'
import { EndpointsEnum } from '@/services/endpoints'
import { TmAuthAccountClosedError } from '@/core/error/transport/auth/TmAuthAccountClosedError'

export const authAccountClosedErrorRule: CustomErrorRule = {
  endpoint: EndpointsEnum.login,
  subCodes: ['auth.account_closed'],
  klass: TmAuthAccountClosedError,
}
